/* eslint-disable import/default */
/* eslint-disable consistent-default-export-name/default-export-match-filename */
import React from 'react'
import { HeaderCompact as OriginalHeaderCompact } from '@betterplace/design-system/page-parts'

function HeaderCompactWithChildren(props) {
  return React.createElement(
    OriginalHeaderCompact,
    { text: props.text },
    React.createElement('div', {
      dangerouslySetInnerHTML: { __html: props.children ?? '' },
    })
  )
}

/**
 * @typedef {import('react').ComponentProps<typeof OriginalHeaderCompact>} HeaderCompactProps
 */

/**
 * @type {HeaderCompactProps}
 */
HeaderCompactWithChildren.railsProps = {
  text: {
    homePageUrl: `<%= root_url %>`,
    logoAlt: `<%= t('layouts.header.logo_alt_text') %>`,
    claim: `<%= t('layouts.header.claim') %>`,
  },
  children: '',
}

HeaderCompactWithChildren.railsTemplateFile = 'domains/donate/views/shared/_donation_header.html.erb'

export const HeaderCompact = OriginalHeaderCompact

export default HeaderCompactWithChildren
